<template>
	<div class="page_content explore_entity_inside faq program_guide_faq" aria-label="program guide faq">

		<div class="row page-heading">
      		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 input module_heading">
        		<span class="module_icon icon-list"></span>
        		<template v-if="formattedProgramGuide && formattedProgramGuide.title">
              <program-guide-title :program-guide="formattedProgramGuide"></program-guide-title>
            </template>
      		</div>
    </div>


		<div class="page_content_container">
    		<div v-if="formattedProgramGuide && formattedProgramGuide.cipCode">
      			<program-guide-menu
          			:cipCode="formattedProgramGuide.cipCode"
          			:programGuideCode="formattedProgramGuide.code"
          			:type="formattedProgramGuide.type"
          			:returnTo="returnTo"
          			:active="'FAQ'">
      			</program-guide-menu>
    		</div>
        <div class="pg_content row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

								<div class="row sub_hd">
									<div class="col-8 hd_txt">
										<div v-if="programGuideObject.faqGroup.label">
											{{programGuideObject.faqGroup.label}}
										</div>

										<div v-if="programGuideObject.faqGroup.detail">
											{{programGuideObject.faqGroup.detail}}
										</div>
									</div>
									<div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 search_bx_sec">
										<div class="search-box-container">
											<input class="input-search" placeholder="search" aria-label="search" v-model="searchTerm" v-on:keyup.enter="searchClicked">
	                  	<b-btn class="btn btn_srh" @click="searchClicked"><span class="fas fa-search" aria-label="search"></span></b-btn>
	                	</div>
									</div>
								</div>

                <template v-if="filteredFAQ.length == 0">
                	<div class="list_row">
										No results found!
                	</div>
                </template>
<!-- Credential -->
                <template v-if="programGuideObject.credentialList.length>0">
                  <div class="accordion_panel">
                      <div class="accordion_crd">
                          <b-card-header header-tag="header" class="row crd_hd" role="tab" block v-b-toggle="'cred'" variant="info">
                            <div class="col-1 ic_container">
                              <div class="ic ic-expand_r"></div>
                              <div class="ic ic-collapse_r"></div>
                            </div>
                            <div class="col-10 hd_txt">
                              <div>Credentials</div>
                            </div>
                          </b-card-header>

                          <b-collapse id="cred" visible role="tabpanel" class="row">
                            <b-card-body class="accordion_crd_content col-12">
                                <div class="self_reported_courses credential_sec">
                                  <div class="list_container_v4">
                                    <template v-for="(credential, j) in programGuideObject.credentialList">
                                        <div class="row list_row">

                                        	<div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 thumbnail_container" @click.stop="launch(credential)">
																						<div class="thumbnail_img" v-if="credential.icon">
                                        			<img :src="credential.icon" class="img_h_100">
                                        		</div>
																						<div v-else class="default_thumb lg">
																							<span class="ic2 ic24-credential"></span>
																						</div>
																					</div>

                                          <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 entity_detail_section">
																						<div class="row">
																							<div class="col-12 title_row">
																								<div class="title" v-html="credential.title"></div>
																							</div>
																						</div>

																						<div class="row other_info mt-2">
																							<div class="col-12 list_info_row" v-if="credential.issuer">
																								<div class="row">
																									<div class="col-3 info_title">Issued by</div>
																									<div class="col-9 info_val">{{credential.issuer}}</div>
																								</div>
																							</div>
																							<div class="col-12 list_info_row" v-if="credential.deliveryType">
																								<div class="row">
																									<div class="col-3 info_title">Delivery</div>
																									<div class="col-9 info_val">{{credential.deliveryType}}</div>
																								</div>
																							</div>
																							<div class="col-12 list_info_row" v-if="credential.transcript">
																								<div class="row">
																									<div class="col-3 info_title">Transcript</div>
																									<div class="col-9 info_val">{{credential.transcript}}</div>
																								</div>
																							</div>
																						</div>

																						<div class="row description mt-2">
																							<div class="col-12" v-html="credential.description"></div>
																						</div>



																					</div>
                                        </div>

                                    </template>
                                  </div>
                                </div>

                            </b-card-body>
                          </b-collapse>
                        </div>
                    </div>
                  </template>
<!-- Credential End-->
                <template v-for="(faq, i) in filteredFAQ">
									<div class="accordion_panel">
	                	<template v-if="(faq.items && faq.items.length>0)">
										  <div class="accordion_crd">
		                      <b-card-header header-tag="header" class="row crd_hd" role="tab" block v-b-toggle="('req_'+i)" variant="info">
		                        <div class="col-1 ic_container">
		                          <div class="ic ic-expand_r"></div>
		                          <div class="ic ic-collapse_r"></div>
		                        </div>
		                        <div class="col-10 hd_txt">
		                          <div>{{faq.label}}</div>
		                        </div>
		                      </b-card-header>

		                      <b-collapse :id="'req_'+i" visible role="tabpanel">
		                        <b-card-body class="accordion_crd_content">
		                            <div v-if="faq.detail" v-html="faq.detail">
		                            </div>
		                            <div class="self_reported_courses">
		                              <div class="">
		                                <template v-for="(faqItem, j) in faq.items">
		                                    <div class="list_row">
		                                      <div class="col-12 sec_hd">
		                                        <div v-html="faqItem.title"></div>
		                                      </div>
		                                    </div>
		                                    <div class="list_row">
		                                      <div class="col-12 sec_txt">
		                                        <div v-html="faqItem.description"></div>
		                                      </div>
		                                    </div>
		                                </template>
		                              </div>
		                            </div>

		                        </b-card-body>
		                      </b-collapse>
		                    </div>
											</template>
										</div>
                  </template>

            </div>
        </div> <!-- .pg_content -->

		</div> <!-- .page_content_container -->


		<div class="loading-spinner">
			<b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
				<div class="text-center" style="color: #FFF">
					<i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
				</div>
			</b-modal>
		</div>

      <div class="modal_popup_container">
        <b-modal id="userVerificationPopup" ref="newFormModal" centered hide-footer class="usr_verification_popup" no-close-on-backdrop>
          <div slot="modal-header" class="header-section">
            <div class="head_txt">
              Create Your Account To Explore More
            </div>
            <div class="btn_container">
              <button class="btn_close" aria-label="close" @click="closeModalBox">
              <span class="ic-close"></span>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-1 lft_col"></div>
            <div class="col-5 content_col">
              <p>Your institution has made the Pragya Explore app available to you for free.</p>
              <p>Your Data is completely secure. Read our <a v-if="institution.privacyPolicyLink" :href="institution.privacyPolicyLink" target="_blank">Privacy Policy</a> <a v-if="!institution.privacyPolicyLink" href="https://site.pragyasystems.com/privacy-policy/" target="_blank">Privacy Policy</a></p>
              <p v-if="isShowPhoneOnCreateAccountModalEnabled">{{showPhoneOnCreateAccountModalLabel}}</p>
            </div>
            <div class="col-5 content_col">
              <p v-if="newProspectError" class="text-danger">{{newProspectError}}</p>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="firstName">First Name <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="text" v-model.trim="newForm.firstName" placeholder="First Name">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Last Name <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="text" v-model.trim="newForm.lastName" placeholder="Last Name">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Password <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="password" v-model.trim="newForm.password" placeholder="Password">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Confirm Password <sup>*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="password" v-model.trim="repassword" placeholder="Confirm Password">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section" v-if="isShowPhoneOnCreateAccountModalEnabled">
                <div class="col-12">
                  <div class="fld-label" id="lastName">Phone Number <sup v-if="isPhoneRequiredOnCreateAccountModal">*</sup></div>
                </div>
                <div class="col-12">
                  <b-form-input type="text" v-model.trim="newForm.primaryPhoneNumber" placeholder="Phone Number">
                  </b-form-input>
                </div>
              </div>
              <div class="row page_fld_section">
                <div class="col-12">
                  <div class="fld-label" id="lastName">By clicking on Create Account you are accepting our <a v-if="institution.privacyPolicyLink" :href="institution.privacyPolicyLink" target="_blank">Privacy Policy</a> <a v-if="!institution.privacyPolicyLink" href="https://site.pragyasystems.com/privacy-policy/" target="_blank">Privacy Policy</a> & <a href="https://site.pragyasystems.com/terms-of-use/" target="_blank">Terms of Use</a></div>
                </div>
              </div>
              <div class="row popup_btn_container">
                <div class="col-6 pragya_login_lnk">
                </div>
                <div class="col-6 popup_btn">
                  <b-button size="lg" @click="registerProspectiveStudent()"aria-label="verify">Create Account</b-button>
                </div>
              </div>
            </div>
            <div class="col-1 rgt_col"></div>
          </div>
        </b-modal>
      </div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideTitle from './ProgramGuideTitle'
export default {
  name: 'program-guide-faq',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'loadDataFromServer'],
  components: {
    ProgramGuideMenu,
    ProgramGuideTitle
  },
  data: () => {
    return {
      isDataLoaded: false,
      DEFAULT_TYPE: 'MAJOR',
      filteredFAQs:[],
      searchTerm :'',
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults',
      newForm: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        primaryPhoneNumber: ''
      }
    }
  },
beforeRouteLeave (to, from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    let tempUser = localStorage.getItem('tempUser')
    if (tempUser && tempUser === 'true') {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: 'Cannot move past this page till account setup is complete'
      })
      this.showNewFormPopup()
      this.nextPage = next
    } else {
      // Navigate to next view
      next()
    }
  },
  async mounted () {
      this.programGuideObject = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true
      })
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadFinishAccountSetup',
      'loadProgramGuideCareers',
      'setTemporaryUserToFalse'
    ]),
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    launch (object) {
        if(object.url){
          window.open(object.url, '_blank')
        }
    },

    searchClicked(){
      if(!this.searchTerm){
          this.filteredFAQs = this.programGuideObject.faqGroup.faqGroups
      }else{
          let filtered = []
          this.programGuideObject.faqGroup.faqGroups.forEach((faq) => {
              let newFaq  = {'label':faq.label, 'items':[]}
              faq.items.forEach((item) => {
                  if(item.title.toLowerCase().indexOf(this.searchTerm.toLowerCase())!=-1 || item.description.toLowerCase().indexOf(this.searchTerm.toLowerCase())!=-1 )
                  newFaq.items.push(item)
              });
              filtered.push(newFaq)
          });
          this.filteredFAQs = filtered;
      }
    },
    async registerProspectiveStudent () {
      if (this.newForm.firstName.length < 1 || this.newForm.lastName.length < 1 || this.newForm.password.length < 1) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'First Name, Last Name and Password are required'
        })
      } else if (this.newForm.password !== this.repassword) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Passwords do no match'
        })
      } else if (this.isShowPhoneOnCreateAccountModalEnabled && this.isPhoneRequiredOnCreateAccountModal && this.newForm.primaryPhoneNumber.length < 1) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Phone Number is required'
        })
      } else {
        this.$refs.loadingModal.show()
        await this.loadFinishAccountSetup(this.newForm)
        let bool = false
        this.setTemporaryUserToFalse()
        this.nextPage()
      }
    },
    showNewFormPopup (popupPosition) {
      this.$refs.newFormModal.show()
      $('.usr_verification_popup').removeClass('showAtTop')
      $('.usr_verification_popup').removeClass('showAtBottom')
      $('.usr_verification_popup').addClass('showAtTop')
    },
    closeModalBox () {
      this.$root.$emit('bv::hide::modal', 'userVerificationPopup')
      this.$parent.isShowTagPopup = false
      this.newForm = {
        firstName: '',
        lastName: '',
        password: '',
        primaryPhoneNumber: ''
      }
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    }
  },
  computed: {
    ...mapState({
      'programGuideObject': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'institution': state => state.institution.institution,
      'packages': state => state.institution.packages
    }),
  formattedProgramGuide () {
      let formattedProgramGuide = this.programGuideObject
      this.filteredFAQs = (formattedProgramGuide.faqGroup && formattedProgramGuide.faqGroup.faqGroups)?formattedProgramGuide.faqGroup.faqGroups:[]
      return formattedProgramGuide
    },
    filteredFAQ () {
      return this.filteredFAQs
    },
    formattedCareers () {
      let careers = this.careersObject
      let formattedCareers = []
      if (!careers || !careers.targetOccupations || !careers.targetOccupations.length || !careers.targetOccupations.length === 0) {
        return formattedCareers
      }
      careers.targetOccupations.forEach((career) => {
        formattedCareers.push(JSON.parse(career))
      })
      return formattedCareers
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!formattedCareer || !formattedCareer.uuid) {
        return {}
      }
      return formattedCareer
    },
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideFAQ.vue